import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import Card from '@/components/Card/Card';
import CardBody from '@/components/Card/CardBody';
import CardHeader from '@/components/Card/CardHeader';
import Facilities from '@/components/Facilities';

export default function FacilitiesPage() {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color='primary'>
            <h4>{t('facilities.title')}</h4>
            {errorMessage && <p style={{ color: '#ff0000' }}>{errorMessage}</p>}
          </CardHeader>

          <CardBody>
            <Facilities setErrorMessage={setErrorMessage} />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
